import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { TransferMiners } from "../../api/api";

type MoveDGMemberResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
};

type TranfersInput = {
  serials: string[];
  filter: Object;
  siteName: string;
  dgname?: string;
  target_email?: string;
  target_org_name?: string;
};

export const useTransferMiners = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      serials,
      siteName,
      dgname,
      target_email,
      target_org_name,
      filter,

      token,
    }: TranfersInput & {
      token: string;
    }): Promise<MoveDGMemberResult> =>
      TransferMiners(token, {
        serials,
        siteName,
        dgname,
        target_email,
        target_org_name,
        filter,
      }),

    onSuccess: (data) => {
      console.log("data", data);
    },

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      {
        serials,
        siteName,
        filter,
        dgname,
        target_email,
        target_org_name,
      }: TranfersInput,
      options?: {
        onSuccess?: (data: MoveDGMemberResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutate(
        {
          serials,
          siteName,
          filter,
          dgname,
          target_email,
          target_org_name,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
